module.exports = __webpack_public_path__ + "static/media/cloud-c-v3@2x.afde40ed.png";